import React from "react";
import "./EnvironmentalPolicy.css";

function EnvironmentalPolicy() {
  return (
    <section className="envPage">
      <div className="envPage-container">
        <h1 className="envPage-title">Environmental Policy</h1>

        <p className="envPage-text">
          Jaltaara Resort is committed to preserving the natural beauty of
          Tetali – New Mahabaleshwar. Our operations follow eco-friendly
          practices to reduce environmental impact and promote sustainability.
        </p>

        <h3 className="envPage-heading">1. Energy Conservation</h3>
        <p className="envPage-text">
          We use energy-efficient lighting, responsibly sourced materials, and
          ensure minimal energy wastage across the property.
        </p>

        <h3 className="envPage-heading">2. Waste Management</h3>
        <p className="envPage-text">
          Waste is segregated and disposed of responsibly. We promote reduced
          plastic use and encourage recycling.
        </p>

        <h3 className="envPage-heading">3. Water Conservation</h3>
        <p className="envPage-text">
          Rainwater harvesting and water-saving fixtures help us maintain
          sustainable water usage.
        </p>

        <h3 className="envPage-heading">4. Respecting Local Ecology</h3>
        <p className="envPage-text">
          We are committed to maintaining the natural greenery, wildlife, and
          ecological balance surrounding the resort.
        </p>
      </div>
    </section>
  );
}

export default EnvironmentalPolicy;
